// import React, { useEffect, useRef, useState } from "react";
// import "bootstrap/dist/css/bootstrap.min.css";
// import { IoClose } from "react-icons/io5";
// import Modal from "react-bootstrap/Modal";
// import { useSelector } from "react-redux";
// import FullPageLoader from "./loader/FullPageLoader";
// import { Link } from "react-router-dom";
// import ReactPaginate from "react-paginate";
// import CkEditor from "./AiEditor/CkEditor";

// const Blogs = () => {
//   const [show, setShow] = useState(false);
//   const [detailShow, setDetailShow] = useState(false);
//   const [editMode, setEditMode] = useState(false);
//   const [expandedRows, setExpandedRows] = useState({});
//   const editorContent = useRef([""]);
//   const editorRef = useRef(null);
//   const [page, setPage] = useState(1);
//   const [pageSize, setPageSize] = useState(10);
//   const [totalCount, setTotalCount] = useState(0);
//   const toggleExpand = (id) => {
//     setExpandedRows((prev) => ({
//       ...prev,
//       [id]: !prev[id],
//     }));
//   };
//   const [modalData, setModalData] = useState({
//     title: "",
//     short_description: "",
//     description: "",
//     createdAt: "",
//     slug_url: "",
//     by_message: "",
//     meta_tags: "",
//   });

//   const handleEditorReady = (editor) => {
//     editorRef.current = editor;
//   };

//   const [userData, setUserData] = useState([]);
//   const [modelDetails, setModelDetails] = useState(null);
//   const [isloading, setLoading] = useState(false);
//   const userId = useSelector((state) => state.auth.userId);

//   useEffect(() => {
//     fetchBlogs();
//   }, [page]);

//   const fetchBlogs = async () => {
//     setLoading(true);
//     try {
//       const response = await fetch(
//         "https://api.greymatterz.com/api/v1/admin/get-blog",
//         {
//           method: "GET",
//           headers: {
//             "Content-Type": "application/json",
//             Authorization:
//               "Bearer gyuastyutadsuy8821345678vsghsjhjksjklsjklskllsjkjtscgcsfgsbjkaw766w8ww990w0",
//           },
//         }
//       );

//       if (!response.ok) {
//         throw new Error(`HTTP error! status: ${response.status}`);
//       }

//       const data = await response.json();

//       setLoading(false);
//       setUserData(data?.data);
//     } catch (error) {
//       setLoading(false);
//       console.error("Error fetching user data:", error);
//     }
//   };

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setModalData({
//       ...modalData,
//       [name]: value,
//     });
//   };

//   const handleSubmit = async () => {
//     setLoading(true);
//     const requestData = {
//       created_by: userId,
//       title: modalData.title,
//       short_description: modalData.short_description,
//       description: editorContent?.current[0],
//       //  modalData.short_description,
//       createdAt: modalData.createdAt,
//       slug_url: modalData.slug_url,
//       by_message: modalData.by_message,
//       meta_tags: modalData.meta_tags,
//     };

//     try {
//       const response = await fetch(
//         "https://api.greymatterz.com/api/v1/create-blog",
//         {
//           method: "POST",
//           headers: {
//             "Content-Type": "application/json",
//             Authorization:
//               "Bearer gyuastyutadsuy8821345678vsghsjhjksjklsjklskllsjkjtscgcsfgsbjkaw766w8ww990w0",
//           },
//           body: JSON.stringify(requestData),
//         }
//       );

//       if (response.ok) {
//         //console.log("Model created successfully");
//         setLoading(false);
//         setShow(false);
//         fetchBlogs();
//       } else {
//         setLoading(false);
//         console.error("Failed to create model");
//       }
//     } catch (error) {
//       console.error("Error creating model:", error);
//     }
//   };

//   const handleUpdate = async () => {
//     setLoading(true);
//     const requestData = {
//       created_by: userId,
//       title: modalData.title,
//       short_description: modalData.short_description,
//       description: editorContent?.current[0],
//       createdAt: modalData.createdAt,
//       slug_url: modalData.slug_url,
//       by_message: modalData.by_message,
//       meta_tags: modalData.meta_tags,
//     };

//     //console.log(requestData);

//     try {
//       const response = await fetch(
//         `https://api.greymatterz.com/api/v1/update-blog/${modelDetails._id}`,
//         {
//           method: "PUT",
//           headers: {
//             "Content-Type": "application/json",
//             Authorization:
//               "Bearer gyuastyutadsuy8821345678vsghsjhjksjklsjklskllsjkjtscgcsfgsbjkaw766w8ww990w0",
//           },
//           body: JSON.stringify(requestData),
//         }
//       );

//       if (response.ok) {
//         //console.log("Model updated successfully");
//         setLoading(false);
//         setDetailShow(false);
//         setEditMode(false);
//         fetchBlogs();
//       } else {
//         console.error("Failed to update model");
//         setLoading(false);
//       }
//     } catch (error) {
//       console.error("Error updating model:", error);
//     }
//   };

//   const handleShowDetails = async (id) => {
//     setLoading(true);
//     try {
//       const response = await fetch(
//         `https://api.greymatterz.com/api/v1/admin/get-blog/${id}`,
//         {
//           method: "GET",
//           headers: {
//             "Content-Type": "application/json",
//             Authorization:
//               "Bearer gyuastyutadsuy8821345678vsghsjhjksjklsjklskllsjkjtscgcsfgsbjkaw766w8ww990w0",
//           },
//         }
//       );

//       if (!response.ok) {
//         throw new Error(`HTTP error! status: ${response.status}`);
//       }

//       const data = await response.json();
//       setLoading(false);
//       setModelDetails(data.data);
//       editorContent.current = [data.data.description];
//       setModalData(data.data || {});
//       setDetailShow(true);
//       setEditMode(false);
//     } catch (error) {
//       setLoading(false);
//       console.error("Error fetching model details:", error);
//     }
//   };

//   const handleStatusToggle = async (id, currentStatus) => {
//     try {
//       const newStatus = !currentStatus;
//       const response = await fetch(
//         `https://api.greymatterz.com/api/v1/update-blog/${id}`,
//         {
//           method: "PUT",
//           headers: {
//             "Content-Type": "application/json",
//             Authorization:
//               "Bearer gyuastyutadsuy8821345678vsghsjhjksjklsjklskllsjkjtscgcsfgsbjkaw766w8ww990w0",
//           },
//           body: JSON.stringify({ created_by: userId, status: newStatus }),
//         }
//       );

//       if (response.ok) {
//         //console.log("Status updated successfully");
//         fetchBlogs(); // Refresh data
//       } else {
//         console.error("Failed to update status");
//       }
//     } catch (error) {
//       console.error("Error updating status:", error);
//     }
//   };

//   const handlePageClick = (selectedPage) => {
//     setPage(selectedPage.selected + 1);
//   };

//   return (
//     <>
//       {isloading ? (
//         <FullPageLoader />
//       ) : (
//         <div className="container-fluid ps-3">
//           <div className="d-flex justify-content-end mb-3">
//             <button
//               className="btn btn-primary"
//               onClick={() => {
//                 editorContent.current = [""];
//                 setShow(true);
//               }}
//             >
//               Create New Blogs
//             </button>
//           </div>

//           <div className="row">
//             <div className="col-lg-12">
//               <div>
//                 <table className="table">
//                   <thead>
//                     <tr>
//                       <th scope="col">S.No</th>
//                       <th scope="col">Title</th>
//                       <th scope="col"> Description</th>
//                       <th scope="col">Slug Url</th>
//                       <th scope="col">Created By</th>
//                       <th scope="col">Meta Tags</th>
//                       <th scope="col">Created At</th>
//                       <th scope="col">Status</th>
//                       <th scope="col"></th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {userData?.map((ele, index) => (
//                       <tr key={index}>
//                         <th scope="row">{index + 1}</th>
//                         <td>{ele?.title}</td>
//                         <td>
//                           {expandedRows[ele?._id]
//                             ? ele?.short_description
//                             : `${ele?.short_description?.slice(0, 200)}...`}
//                           {ele?.short_description?.length > 200 && (
//                             <Link
//                               onClick={() => toggleExpand(ele?._id)}
//                               className="text-blue-500 ml-2"
//                             >
//                               {expandedRows[ele?._id]
//                                 ? "Show Less"
//                                 : "Show More"}
//                             </Link>
//                           )}
//                         </td>

//                         <td>{ele?.slug_url}</td>
//                         <td>{ele?.by_message}</td>
//                         <td>{ele?.meta_tags}</td>
//                         <td>{ele?.createdAt}</td>
//                         <td>
//                           <label className="switch">
//                             <input
//                               type="checkbox"
//                               checked={ele.status}
//                               onChange={() =>
//                                 handleStatusToggle(ele._id, ele.status)
//                               }
//                             />
//                             <span className="slider round"></span>
//                           </label>
//                         </td>
//                         <td>
//                           <button
//                             className="btn btn-info btn-sm"
//                             onClick={() => handleShowDetails(ele._id)}
//                           >
//                             Details
//                           </button>
//                         </td>
//                       </tr>
//                     ))}
//                   </tbody>
//                 </table>
//               </div>
//             </div>
//           </div>
//           <div className="d-flex justify-content-center mt-4">
//             <ReactPaginate
//               previousLabel={"Previous"}
//               nextLabel={"Next"}
//               breakLabel={"..."}
//               breakClassName={"break-me"}
//               pageCount={Math.ceil(totalCount / pageSize)}
//               marginPagesDisplayed={1}
//               pageRangeDisplayed={3}
//               onPageChange={handlePageClick}
//               containerClassName={"pagination"}
//               subContainerClassName={"pages pagination"}
//               activeClassName={"active"}
//               forcePage={page - 1}
//             />
//           </div>
//         </div>
//       )}
//       {/* Create New Blogs Model */}
//       <Modal
//         show={show}
//         onHide={() => {
//           setShow(false);
//         }}
//         size="xl"
//       >
//         <Modal.Body>
//           <h3 className="text-center py-4 position-relative title">
//             Create New Blogs
//             <span
//               className="modalClose"
//               onClick={() => {
//                 setShow(false);
//                 setModalData({});
//               }}
//               style={{ cursor: "pointer" }}
//             >
//               <IoClose />
//             </span>
//           </h3>

//           <div className="p-4">
//             <div className="form-group mb-4">
//               <label>
//                 <h6>Title</h6>
//               </label>
//               <input
//                 type="text"
//                 name="title"
//                 value={modalData.title}
//                 onChange={handleChange}
//                 placeholder="Enter Title"
//                 className="form-control"
//               />

//               <label>
//                 <h6>Short Description</h6>
//               </label>
//               <textarea
//                 name="short_description"
//                 rows="4"
//                 value={modalData.short_description}
//                 onChange={handleChange}
//                 placeholder="Enter Short Description"
//                 className="form-control"
//               />

//               <label>
//                 <h6> Description</h6>
//               </label>
//               {/* <input
//                 type="text"
//                 name="short_description"
//                 value={modalData.short_description}
//                 onChange={handleChange}
//                 placeholder="Enter Short Description"
//                 className="form-control"
//               /> */}
//               <CkEditor
//                 editorContent={editorContent}
//                 editorRef={editorRef}
//                 handleEditorReady={handleEditorReady}
//               />

//               <label>
//                 <h6>Created By Message</h6>
//               </label>
//               <input
//                 type="text"
//                 name="by_message"
//                 value={modalData.by_message}
//                 onChange={handleChange}
//                 placeholder="Enter Created By"
//                 className="form-control"
//               />

//               <label>
//                 <h6>Slug Url</h6>
//               </label>
//               <input
//                 type="text"
//                 name="slug_url"
//                 value={modalData.slug_url}
//                 onChange={handleChange}
//                 placeholder="Enter model type"
//                 className="form-control"
//               />

//               <label>
//                 <h6>Meta Tags</h6>
//               </label>
//               <input
//                 type="text"
//                 name="meta_tags"
//                 value={modalData.meta_tags}
//                 onChange={handleChange}
//                 placeholder="Enter Meta tags"
//                 className="form-control"
//               />
//             </div>
//             <div className="text-center">
//               <button className="btn btn-primary" onClick={handleSubmit}>
//                 Save
//               </button>
//             </div>
//           </div>
//         </Modal.Body>
//       </Modal>

//       {/* Model Details Modal */}
//       <Modal
//         show={detailShow}
//         onHide={() => {
//           setDetailShow(false);
//         }}
//         size="lg"
//       >
//         <Modal.Body>
//           <h3 className="text-center py-4 position-relative title">
//             Blog Details
//             <span
//               className="modalClose"
//               onClick={() => {
//                 setDetailShow(false);
//                 setModalData({});
//               }}
//               style={{ cursor: "pointer" }}
//             >
//               <IoClose />
//             </span>
//           </h3>

//           <div className="p-4">
//             <div className="form-group mb-4">
//               <label>
//                 <h6>Title</h6>
//               </label>
//               <input
//                 type="text"
//                 name="title"
//                 value={modalData.title}
//                 onChange={handleChange}
//                 placeholder="Enter model name"
//                 className="form-control"
//                 disabled={!editMode}
//               />
//               <label>
//                 <h6>Short Description</h6>
//               </label>
//               <textarea
//                 name="short_description"
//                 rows="4"
//                 value={modalData.short_description}
//                 onChange={handleChange}
//                 placeholder="Enter Short Description"
//                 className="form-control"
//               />
//               <label>
//                 <h6> Description</h6>
//               </label>
//               {/* <input
//                 type="text"
//                 name="short_description"
//                 value={modalData.short_description}
//                 onChange={handleChange}
//                 placeholder="Enter short description"
//                 className="form-control"
//                 disabled={!editMode}
//               /> */}
//               <CkEditor
//                 editorContent={editorContent}
//                 editorRef={editorRef}
//                 handleEditorReady={handleEditorReady}
//               />

//               <label>
//                 <h6>Created By Message</h6>
//               </label>
//               <input
//                 type="text"
//                 name="by_message"
//                 value={modalData.by_message}
//                 onChange={handleChange}
//                 placeholder="Enter created by message"
//                 className="form-control"
//                 disabled={!editMode}
//               />

//               <label>
//                 <h6>Slug Url</h6>
//               </label>
//               <input
//                 type="text"
//                 name="slug_url"
//                 value={modalData.slug_url}
//                 onChange={handleChange}
//                 placeholder="Enter model type"
//                 className="form-control"
//                 disabled={!editMode}
//               />

//               <label>
//                 <h6>Meta Tags</h6>
//               </label>
//               <input
//                 type="text"
//                 name="meta_tags"
//                 value={modalData.meta_tags}
//                 onChange={handleChange}
//                 placeholder="Enter Meta Tags"
//                 className="form-control"
//                 disabled={!editMode}
//               />
//             </div>
//             <div className="text-center">
//               {editMode ? (
//                 <>
//                   <button
//                     className="btn btn-success me-2"
//                     onClick={handleUpdate}
//                   >
//                     Update
//                   </button>
//                   <button
//                     className="btn btn-secondary"
//                     onClick={() => setEditMode(false)}
//                   >
//                     Cancel
//                   </button>
//                 </>
//               ) : (
//                 <button
//                   className="btn btn-primary"
//                   onClick={() => setEditMode(true)}
//                 >
//                   Edit
//                 </button>
//               )}
//             </div>
//           </div>
//         </Modal.Body>
//       </Modal>
//     </>
//   );
// };

// export default Blogs;

import React, { useEffect, useRef, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { IoClose } from "react-icons/io5";
import { useSelector } from "react-redux";
import FullPageLoader from "./loader/FullPageLoader";
import { Link } from "react-router-dom";
import ReactPaginate from "react-paginate";
import HTMLEditor from "./HtmlEditior/HTMLEditor";

const Blogs = () => {
  const [show, setShow] = useState(false);
  const [detailShow, setDetailShow] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [expandedRows, setExpandedRows] = useState({});
  // const editorContent = useRef([""]);
  const editorRef = useRef(null);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalCount, setTotalCount] = useState(0);

  const [savedContent, setSavedContent] = useState("");
  const [showPreview, setShowPreview] = useState(false);
  const [editorContent, setEditorContent] = useState("");

  // console.log("Editor Content:", editorContent);

  const handleEditorChange = (content) => {
    setEditorContent(content);
  };

  const handleSave = (content) => {
    setSavedContent(content);
    alert("Content saved successfully!");
    console.log("Saved content:", content);
  };

  const handleExportHTML = () => {
    const blob = new Blob([editorContent], { type: "text/html" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = "editor-content.html";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  const handleClear = () => {
    if (window.confirm("Are you sure you want to clear all content?")) {
      setEditorContent("");
    }
  };
  const toggleExpand = (id) => {
    setExpandedRows((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };
  const [modalData, setModalData] = useState({
    title: "",
    short_description: "",
    description: "",
    createdAt: "",
    slug_url: "",
    by_message: "",
    meta_tags: "",
  });

  const handleEditorReady = (editor) => {
    editorRef.current = editor;
  };

  const [userData, setUserData] = useState([]);
  const [modelDetails, setModelDetails] = useState(null);
  const [isloading, setLoading] = useState(false);
  const userId = useSelector((state) => state.auth.userId);

  useEffect(() => {
    fetchBlogs();
  }, [page]);

  const fetchBlogs = async () => {
    setLoading(true);
    try {
      const response = await fetch(
        "https://api.greymatterz.com/api/v1/admin/get-blog",
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization:
              "Bearer gyuastyutadsuy8821345678vsghsjhjksjklsjklskllsjkjtscgcsfgsbjkaw766w8ww990w0",
          },
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();

      setLoading(false);
      setUserData(data?.data);
    } catch (error) {
      setLoading(false);
      console.error("Error fetching user data:", error);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setModalData({
      ...modalData,
      [name]: value,
    });
  };

  const handleSubmit = async () => {
    setLoading(true);
    const requestData = {
      created_by: userId,
      title: modalData.title,
      short_description: modalData.short_description,
      description: editorContent,
      createdAt: modalData.createdAt,
      slug_url: modalData.slug_url,
      by_message: modalData.by_message,
      meta_tags: modalData.meta_tags,
    };

    try {
      const response = await fetch(
        "https://api.greymatterz.com/api/v1/create-blog",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization:
              "Bearer gyuastyutadsuy8821345678vsghsjhjksjklsjklskllsjkjtscgcsfgsbjkaw766w8ww990w0",
          },
          body: JSON.stringify(requestData),
        }
      );

      if (response.ok) {
        setLoading(false);
        setShow(false);
        fetchBlogs();
      } else {
        setLoading(false);
        console.error("Failed to create model");
      }
    } catch (error) {
      console.error("Error creating model:", error);
    }
  };

  const handleUpdate = async () => {
    setLoading(true);
    const requestData = {
      created_by: userId,
      title: modalData.title,
      short_description: modalData.short_description,
      description: editorContent,
      createdAt: modalData.createdAt,
      slug_url: modalData.slug_url,
      by_message: modalData.by_message,
      meta_tags: modalData.meta_tags,
    };

    try {
      const response = await fetch(
        `https://api.greymatterz.com/api/v1/update-blog/${modelDetails._id}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization:
              "Bearer gyuastyutadsuy8821345678vsghsjhjksjklsjklskllsjkjtscgcsfgsbjkaw766w8ww990w0",
          },
          body: JSON.stringify(requestData),
        }
      );

      if (response.ok) {
        setLoading(false);
        setDetailShow(false);
        setEditMode(false);
        fetchBlogs();
      } else {
        console.error("Failed to update model");
        setLoading(false);
      }
    } catch (error) {
      console.error("Error updating model:", error);
    }
  };

  const handleShowDetails = async (id) => {
    setLoading(true);
    try {
      const response = await fetch(
        `https://api.greymatterz.com/api/v1/admin/get-blog/${id}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization:
              "Bearer gyuastyutadsuy8821345678vsghsjhjksjklsjklskllsjkjtscgcsfgsbjkaw766w8ww990w0",
          },
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      setLoading(false);
      setModelDetails(data.data);
      // editorContent.current = [data.data.description];
      console.log("Blog Description:", data.data.description);
      setEditorContent(data.data.description);
      setModalData(data.data || {});
      setDetailShow(true);
      setEditMode(false);
    } catch (error) {
      setLoading(false);
      console.error("Error fetching model details:", error);
    }
  };

  const handleStatusToggle = async (id, currentStatus) => {
    try {
      const newStatus = !currentStatus;
      const response = await fetch(
        `https://api.greymatterz.com/api/v1/update-blog/${id}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization:
              "Bearer gyuastyutadsuy8821345678vsghsjhjksjklsjklskllsjkjtscgcsfgsbjkaw766w8ww990w0",
          },
          body: JSON.stringify({ created_by: userId, status: newStatus }),
        }
      );

      if (response.ok) {
        fetchBlogs();
      } else {
        console.error("Failed to update status");
      }
    } catch (error) {
      console.error("Error updating status:", error);
    }
  };

  const handlePageClick = (selectedPage) => {
    setPage(selectedPage.selected + 1);
  };

  // ------------------ RETURN ------------------
  if (show) {
    return (
      <div className="container mt-4">
        <h3 className="text-center py-4 position-relative title">
          Create New Blogs
          <span
            className="modalClose position-absolute end-0 me-3"
            onClick={() => {
              setShow(false);
              setModalData({});
            }}
            style={{ cursor: "pointer" }}
          >
            <IoClose />
          </span>
        </h3>

        <div className="p-4">
          <div className="form-group mb-4">
            <label>
              <h6>Title</h6>
            </label>
            <input
              type="text"
              name="title"
              value={modalData.title}
              onChange={handleChange}
              placeholder="Enter Title"
              className="form-control"
            />

            <label>
              <h6>Short Description</h6>
            </label>
            <textarea
              name="short_description"
              rows="4"
              value={modalData.short_description}
              onChange={handleChange}
              placeholder="Enter Short Description"
              className="form-control"
            />

            <label>
              <h6>Description</h6>
            </label>
            {/* <CkEditor
              editorContent={editorContent}
              editorRef={editorRef}
              handleEditorReady={handleEditorReady}
            /> */}

            <HTMLEditor
              value={editorContent}
              onChange={handleEditorChange}
              height="600px"
              placeholder="Start typing your amazing content..."
              onSave={handleSave}
              enableImageUpload={true}
              enableContextMenu={true}
              theme="light"
              userId="679086ffffb3896f0da4b84a"
            />

            <label>
              <h6>Created By Message</h6>
            </label>
            <input
              type="text"
              name="by_message"
              value={modalData.by_message}
              onChange={handleChange}
              placeholder="Enter Created By"
              className="form-control"
            />

            <label>
              <h6>Slug Url</h6>
            </label>
            <input
              type="text"
              name="slug_url"
              value={modalData.slug_url}
              onChange={handleChange}
              placeholder="Enter model type"
              className="form-control"
            />

            <label>
              <h6>Meta Tags</h6>
            </label>
            <input
              type="text"
              name="meta_tags"
              value={modalData.meta_tags}
              onChange={handleChange}
              placeholder="Enter Meta tags"
              className="form-control"
            />
          </div>
          <div className="text-center">
            <button className="btn btn-primary me-2" onClick={handleSubmit}>
              Save
            </button>
            <button
              className="btn btn-secondary"
              onClick={() => setShow(false)}
            >
              Back
            </button>
          </div>
        </div>
      </div>
    );
  }

  if (detailShow) {
    return (
      <div className="container mt-4">
        <h3 className="text-center py-4 position-relative title">
          Blog Details
          <span
            className="modalClose position-absolute end-0 me-3"
            onClick={() => {
              setDetailShow(false);
              setModalData({});
            }}
            style={{ cursor: "pointer" }}
          >
            <IoClose />
          </span>
        </h3>

        <div className="p-4">
          <div className="form-group mb-4">
            <label>
              <h6>Title</h6>
            </label>
            <input
              type="text"
              name="title"
              value={modalData.title}
              onChange={handleChange}
              className="form-control"
              disabled={!editMode}
            />

            <label>
              <h6>Short Description</h6>
            </label>
            <textarea
              name="short_description"
              rows="4"
              value={modalData.short_description}
              onChange={handleChange}
              className="form-control"
            />

            <label>
              <h6>Description</h6>
            </label>
            {/* <CkEditor
              editorContent={editorContent}
              editorRef={editorRef}
              handleEditorReady={handleEditorReady}
            /> */}

            <HTMLEditor
              value={editorContent}
              onChange={handleEditorChange}
              height="600px"
              placeholder="Start typing your amazing content..."
              onSave={handleSave}
              enableImageUpload={true}
              enableContextMenu={true}
              theme="light"
              userId="679086ffffb3896f0da4b84a"
            />

            <label>
              <h6>Created By Message</h6>
            </label>
            <input
              type="text"
              name="by_message"
              value={modalData.by_message}
              onChange={handleChange}
              className="form-control"
              disabled={!editMode}
            />

            <label>
              <h6>Slug Url</h6>
            </label>
            <input
              type="text"
              name="slug_url"
              value={modalData.slug_url}
              onChange={handleChange}
              className="form-control"
              disabled={!editMode}
            />

            <label>
              <h6>Meta Tags</h6>
            </label>
            <input
              type="text"
              name="meta_tags"
              value={modalData.meta_tags}
              onChange={handleChange}
              className="form-control"
              disabled={!editMode}
            />
          </div>

          <div className="text-center">
            {editMode ? (
              <>
                <button className="btn btn-success me-2" onClick={handleUpdate}>
                  Update
                </button>
                <button
                  className="btn btn-secondary"
                  onClick={() => setEditMode(false)}
                >
                  Cancel
                </button>
              </>
            ) : (
              <button
                className="btn btn-primary me-2"
                onClick={() => setEditMode(true)}
              >
                Edit
              </button>
            )}
            <button
              className="btn btn-secondary"
              onClick={() => setDetailShow(false)}
            >
              Back
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <>
      {isloading ? (
        <FullPageLoader />
      ) : (
        <div className="container-fluid ps-3">
          <div className="d-flex justify-content-end mb-3">
            <button
              className="btn btn-primary"
              onClick={() => {
                setEditorContent("");
                setShow(true);
              }}
            >
              Create New Blogs
            </button>
          </div>

          <div className="row">
            <div className="col-lg-12">
              <div>
                <table className="table">
                  <thead>
                    <tr>
                      <th>S.No</th>
                      <th>Title</th>
                      <th>Description</th>
                      <th>Slug Url</th>
                      <th>Created By</th>
                      <th>Meta Tags</th>
                      <th>Created At</th>
                      <th>Status</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {userData?.map((ele, index) => (
                      <tr key={index}>
                        <th scope="row">{index + 1}</th>
                        <td>{ele?.title}</td>
                        <td>
                          {expandedRows[ele?._id]
                            ? ele?.short_description
                            : `${ele?.short_description?.slice(0, 200)}...`}
                          {ele?.short_description?.length > 200 && (
                            <Link
                              onClick={() => toggleExpand(ele?._id)}
                              className="text-blue-500 ml-2"
                            >
                              {expandedRows[ele?._id]
                                ? "Show Less"
                                : "Show More"}
                            </Link>
                          )}
                        </td>

                        <td>{ele?.slug_url}</td>
                        <td>{ele?.by_message}</td>
                        <td>{ele?.meta_tags}</td>
                        <td>{ele?.createdAt}</td>
                        <td>
                          <label className="switch">
                            <input
                              type="checkbox"
                              checked={ele.status}
                              onChange={() =>
                                handleStatusToggle(ele._id, ele.status)
                              }
                            />
                            <span className="slider round"></span>
                          </label>
                        </td>
                        <td>
                          <button
                            className="btn btn-info btn-sm"
                            onClick={() => handleShowDetails(ele._id)}
                          >
                            Details
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <div className="d-flex justify-content-center mt-4">
            <ReactPaginate
              previousLabel={"Previous"}
              nextLabel={"Next"}
              breakLabel={"..."}
              pageCount={Math.ceil(totalCount / pageSize)}
              marginPagesDisplayed={1}
              pageRangeDisplayed={3}
              onPageChange={handlePageClick}
              containerClassName={"pagination"}
              activeClassName={"active"}
              forcePage={page - 1}
            />
          </div>
        </div>
      )}
    </>
  );
};

export default Blogs;
